import { CampaignBriefForm } from "../types/campaign-brief-form/campaign-brief-form.interface";
import { Observable, throwError } from "rxjs";
import { map } from "rxjs/operators";
import { mapCampaignBriefFormToParams } from "../types/campaign-brief-form/campaign-brief-form.functions";
import { ICampaignBriefData } from "../types/campaign-brief-state/campaign-brief-state.interface";
import { DuplicateCampaignBriefForm } from "../types/duplicate-campaign-brief-form.interface";
import { CreateCampaignBriefForm } from "../types/create-campaign-brief-form.interface";
import * as http from "../../../services/http.service";

export function fetchBrief(id: number): Observable<ICampaignBriefData> {
  return http.get<ICampaignBriefData>(`/campaign-briefs/${id}/`).pipe(
    map((data) => {
      if (!data) {
        throwError("No data in network response");
      }
      return data;
    })
  );
}

export function create(form: CreateCampaignBriefForm): Observable<ICampaignBriefData> {
  return http.post<ICampaignBriefData>("/campaign-briefs/", form);
}

export function resetBrief(id: number): Observable<ICampaignBriefData> {
  return http.put<ICampaignBriefData>(`/campaign-briefs/${id}/reset/`);
}

export function updateBrief(form: CampaignBriefForm): Observable<ICampaignBriefData> {
  return http
    .patch<ICampaignBriefData>(`/campaign-briefs/${form.id}/`, mapCampaignBriefFormToParams(form))
    .pipe(
      map((data) => {
        if (!data) {
          throwError("No data in network response");
        }
        return data;
      })
    );
}

export function renameBrief(form: CampaignBriefForm): Observable<ICampaignBriefData> {
  return http
    .patch<ICampaignBriefData>(`/campaign-briefs/${form.id}/change-name/`, {
      name: form.campaignName,
    })
    .pipe(
      map((data) => {
        if (!data) {
          throwError("No data in network response");
        }
        return data;
      })
    );
}

export function duplicate(form: DuplicateCampaignBriefForm): Observable<ICampaignBriefData> {
  return http.post<ICampaignBriefData>("/campaign-briefs/clone/", form);
}

export function exportBriefEndpoint(briefId: number): string {
  return `/campaign-briefs/${briefId}/export/`;
}

export function startReview(id: number): Observable<ICampaignBriefData> {
  return http.put<ICampaignBriefData>(`/campaign-briefs/${id}/start-review/`);
}

export function search(searchTerm: string): Observable<any> {
  const searchUrl = `/search/campaign-briefs/?name__contains=${searchTerm}`;
  return http.get<any>(searchUrl).pipe(
    map((data) => {
      if (!data) {
        throwError("No matching campaign briefs");
      }
      return data.results;
    })
  );
}
